"use client";

import { useState } from "react";
import SingleBlog from "@/components/Blog/SingleBlog";
import blogData from "@/components/Blog/blogData";
import Breadcrumb from "@/components/Common/Breadcrumb";

const BLOGS_PER_PAGE = 3;

const Blog = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(blogData.length / BLOGS_PER_PAGE);

  const startIndex = (currentPage - 1) * BLOGS_PER_PAGE;
  const currentBlogs = blogData.slice(startIndex, startIndex + BLOGS_PER_PAGE);

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <>
      <Breadcrumb
        pageName="Our Blogs"
        description="Explore the latest insights, tutorials, and updates from Devkin Technology."
      />

      <section className="pt-[100px] pb-[100px]">
        <div className="container">
          <div className="-mx-4 flex flex-wrap justify-center">
            {currentBlogs.map((blog) => (
              <div key={blog.id} className="mb-8 w-full px-4 md:w-1/2 xl:w-1/3">
                <SingleBlog blog={blog} />
              </div>
            ))}
          </div>

          <div className="mt-12 flex justify-center">
            <ul className="flex items-center space-x-2">
              <li>
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className={`rounded-md px-4 py-2 text-sm transition ${
                    currentPage === 1
                      ? "cursor-not-allowed bg-gray-200 text-gray-400"
                      : "bg-gray-100 text-gray-600 hover:bg-gradient-to-r hover:from-blue-400 hover:to-blue-600 hover:text-white"
                  }`}
                >
                  Prev
                </button>
              </li>

              {Array.from({ length: totalPages }).map((_, index) => {
                const page = index + 1;
                return (
                  <li key={page}>
                    <button
                      onClick={() => handlePageChange(page)}
                      className={`rounded-md px-4 py-2 text-sm transition ${
                        currentPage === page
                          ? "bg-gradient-to-r from-blue-400 to-blue-600 text-white"
                          : "bg-gray-100 text-gray-600 hover:bg-gradient-to-r hover:from-blue-400 hover:to-blue-600 hover:text-white"
                      }`}
                    >
                      {page}
                    </button>
                  </li>
                );
              })}

              <li>
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className={`rounded-md px-4 py-2 text-sm transition ${
                    currentPage === totalPages
                      ? "cursor-not-allowed bg-gray-200 text-gray-400"
                      : "bg-gray-100 text-gray-600 hover:bg-gradient-to-r hover:from-blue-400 hover:to-blue-600 hover:text-white"
                  }`}
                >
                  Next
                </button>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
